import moment from 'moment';
import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { calcInterval } from '@src/store/timeline/utils';
import { DASHBOARD_TYPE, TEMP_DASHBOARD_URL } from '@src/utils/constants';
import { HandlerOptions } from './types';

/**
 * Handles fetch_session_timeline_json tool - opens session timeline in a new tab
 * Follows the same pattern as RenderViewerSession.tsx getNewTabUrl
 */
export const handleSessionTimeline = (options: HandlerOptions): void => {
  try {
    const { args } = options;
    const { client_id, session_id, session_start_time_ms, session_end_time_ms } = args || {};

    // Validate required parameters
    if (!client_id || !session_id || !session_start_time_ms) {
      logger.error('Missing required parameters for session timeline', { args });
      return;
    }

    // Convert timestamps to ISO strings
    const sessionStartTime = moment(session_start_time_ms).toISOString();
    const sessionEndTime = session_end_time_ms ? moment(session_end_time_ms).toISOString() : null;

    // Timeline interval delegated to calcInterval:
    // - Usable sessionEndTime → last 24h of the session (+ 30m buffer), capped to now.
    // - Missing sessionEndTime → anchored on sessionStartTime: [start, min(start + 24h, now)].
    const timelineInterval = calcInterval({ sessionStartTime, sessionEndTime });

    // Build URL with query parameters (same as RenderViewerSession.tsx getNewTabUrl)
    const tempDashboardBaseUrl = TEMP_DASHBOARD_URL[DASHBOARD_TYPE.TEMP_TAB];
    const sessionEndParam = sessionEndTime ? `&sessionEndTime=${sessionEndTime}` : '';
    const url = `${tempDashboardBaseUrl}timeline?clientId=${client_id}&sessionId=${session_id}&timelineInterval=${timelineInterval}&sessionStartTime=${sessionStartTime}${sessionEndParam}`;

    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'session_timeline', url });
      logger.log('Opened session timeline in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling session timeline:', error);
  }
};
